// extracted by mini-css-extract-plugin
export default {"image":"Y3-z","loaded":"Z3-z"};